export let PricingType = /*#__PURE__*/function (PricingType) {
  PricingType["Free"] = "free";
  PricingType["Plan"] = "plan";
  PricingType["Subscription"] = "subscription";
  return PricingType;
}({});
//# sourceMappingURL=pricing-type.js.map